import React, { Component } from 'react';

import LedgerGroup from './ledger_group';

export default class Ledger extends Component {
    render() {
        const { timers, realtor, agentHours, exportPDF } = this.props;
        const groups = sortTimersRealtor(timers);
        return (
          Object.values(groups).map(group => {
            return (
                <LedgerGroup
                  agentHours={agentHours}
                  realtor={realtor}
                  export={exportPDF}
                  title={group.title}
                  dates={group.timers}
                  key={group.title} />
            )
          }
        )
      )
    }
  }


function sortTimersRealtor(timers) {
  let groups = {};
  console.log(timers)
  if (timers){
  for (let timer of Object.values(timers)) {
    if (!groups[timer.agent]) {
      groups[timer.agent] ={
        title: timer.agent,
        timers: []
      }
    }
    groups[timer.agent].timers.push(timer)
  }
  return groups;
}
}



// WEBPACK FOOTER //
// ./src/components/timetracker/ledger.jsx